// lets users tab into card styles to select
const handleEnterPressEvent = (e: any, pressEvent: Function) => {
    if (e?.code === 'Enter') {
        e.preventDefault()
        pressEvent()
    }
}

export default handleEnterPressEvent
